// Hauteurs de base (avant zoom de l'interface). L'en-tête compte 1 ligne, ou 2
// quand les onglets de catalogue n'y tiennent pas ; la ligne des notes se
// replie quand aucun catalogue n'est ouvert. Hauteurs effectives :
// cf. stores/CanvasLayoutState.ts.
export const HEADER_ROW_HEIGHT = 34;
export const DRAGGER_ROW_HEIGHT = 38;
export const DRAWER_WIDTH = 300;

export const VERTICAL_DRAGGABLE_WIDTH_DEFAULT = 150;
export const VERTICAL_TAB_COL_WIDTH = 28;
export const VERTICAL_DRAGGABLE_MIN_WIDTH = 100;
export const VERTICAL_DRAGGABLE_MAX_WIDTH = 400;

// Z-index layers (higher = on top)
export const Z_INDEX_OVERLAY = 10; // Ruler overlay - above canvas
export const Z_INDEX_LOADER = 50; // Loading spinner - above canvas, below toolbar
export const Z_INDEX_TOOLBAR = 100; // Toolbars - above overlay and loader
export const Z_INDEX_ALERT = 500; // Alerts (memory) - above toolbars, below drawers
export const Z_INDEX_DRAWER = 1000; // Drawer menus - above everything
export const Z_INDEX_HINT = 1100; // Contextual tool hint - above drawers and toolbars
export const Z_INDEX_SELECTION = 1200; // Selection bar - the one thing above the hint
export const Z_INDEX_MODAL = 2000; // Modals - above drawers
